import { Injectable } from '@angular/core';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';

@Injectable({
  providedIn: 'root'
})
export class PhotoService {

  constructor(private camera: Camera) { }

  currentImage: any;
  fileImage: any;

  takePicture(callback: (() => void) = (() => {})) {
    const options: CameraOptions = {
      quality: 30,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      correctOrientation: true,
      mediaType: this.camera.MediaType.PICTURE
    };

    this.camera.getPicture(options).then((imageData) => {

      this.currentImage = 'data:image/jpeg;base64,' + imageData;
      let blob = this.getBlob(imageData, '.jpg');
      this.fileImage = new File([blob], 'image.jpg', {type: 'image/jpeg'});

      if (callback) {
        callback();
      }

    }, (err) => {
      // Handle error
      console.log('Camera issue edit: ', err);
    }).catch((error) => {
      console.log("error");
      console.log(error);
    });
  }

  private getBlob(b64Data: string, contentType: string, sliceSize: number = 512) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    let byteCharacters = atob(b64Data);
    let byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);

      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      let byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }
    let blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

}
